type GetCurrentYearType = {
	year: string;
	maxDate?: Date;
	minDate?: Date;
};

const getCurrentYear = ({year, maxDate, minDate}: GetCurrentYearType) => {
	const currentYear = !year.length ? new Date().getFullYear() : Number(year);
	if (maxDate && year && currentYear > maxDate.getFullYear()) {
		return maxDate.getFullYear();
	}
	if (minDate && year && currentYear < minDate.getFullYear()) {
		return minDate.getFullYear();
	}
	return currentYear;
};

export {getCurrentYear};
